(function ({ jQuery: $ }) {
  /*! ===== 여기에 스크립트를 작성해 주세요. ===== */

  $(document).ready(function () {
    //investments sector
    var sectors_tab = $('#sectors .tab_cont .tab_btn');

    sectors_tab.click(function () {
      $(this).toggleClass('on');
      if ($(this).hasClass('on')) {
        sectors_tab.removeClass('on');
        sectors_tab.next().removeClass('view');
        $(this).addClass('on');
        $(this).next().addClass('view');
        $('#sectors .tab_cont').addClass('on');
      } else {
        $(this).removeClass('on');
        $(this).next().removeClass('view');
        $('#sectors .tab_cont').removeClass('on');
      }
    });
  });
})(
  (function (jQuery) {
    requireModule('jQuery', typeof jQuery === 'function');

    function requireModule(name, predicate) {
      if (!predicate) {
        throw new Error(
          `Unable to find ${name} module. Please make sure it is loaded before this script.`
        );
      }
    }

    return { jQuery };
  })(window.jQuery, window.KeenSlider)
);
